<div mat-dialog-title>
    <span>{{'action.configuration' | translate}}</span>
    <button  [mat-dialog-close]="data">
        <i class="fa fa-times"></i>
    </button>
</div>

<mat-dialog-content>
    <!-- PART 2 -->
    <!-- <div [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="">
        <h3>{{'stations.form.label.groupingStations' | translate}}</h3>
        
        <div class="wrap-file-actions">
            <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadEvent($event)" [backendResponse]="backendResponseDownloadedFile"></app-file-download>
            <app-file-upload (userWantsUploadEvent)="onUserWantsUploadEvent($event)" [backendResponse]="backendResponseUploadedFile"></app-file-upload>
        </div>
    </div> instance-->
    <div class="">
        <h3>{{'stations.modal.configuration.import_export' | translate}}</h3>
        
        <div class="wrap-file-actions">
            <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadStationsEvent($event)" [backendResponse]="backendResponseDownloadedFileStations"></app-file-download>
            <app-file-upload appReadWrite (userWantsUploadEvent)="onUserWantsUploadStationsEvent($event)" [backendResponse]="backendResponseUploadedFileStations"></app-file-upload>
        </div>
    </div>
</mat-dialog-content>